(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vuetify/lib"), require("luxon"), require("numeral"));
	else if(typeof define === 'function' && define.amd)
		define(["vuetify/lib", "luxon", "numeral"], factory);
	else if(typeof exports === 'object')
		exports["cove"] = factory(require("vuetify/lib"), require("luxon"), require("numeral"));
	else
		root["cove"] = factory(root[undefined], root[undefined], root[undefined]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4875__, __WEBPACK_EXTERNAL_MODULE__5b4c__, __WEBPACK_EXTERNAL_MODULE_e428__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "1047":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  props: {
    value: {
      type: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasFieldErrors() {
      return this.$store.getters['cove/errors/hasFieldErrors'](this.$vnode.key);
    }

  },
  methods: {
    focus() {
      this.$refs.proxy.focus();
    },

    trimToNull(value) {
      let result = value;

      if (typeof value === 'string') {
        result = value.trim();

        if (result === '') {
          result = null;
        }
      }

      return result;
    },

    mixinRequired(attributes) {
      if (this.required) {
        // vuetify, although undocumented, adds in the appropriate 'required' attribute to the input with this flag set
        // if that ever changes we may need to do it manually.
        attributes.required = true;
        attributes.label += ' *';
      }
    }

  }
});

/***/ }),

/***/ "26f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-checkbox.vue?vue&type=template&id=1a2bb01e&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._g(_vm._b({ref:"proxy",attrs:{"input-value":_vm.value,"error":_vm.hasFieldErrors},on:{"change":_vm.$listeners.input},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-checkbox',_vm.attributes,false),_vm.listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-checkbox.vue?vue&type=template&id=1a2bb01e&

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-checkbox.vue?vue&type=script&lang=js&
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var c_checkboxvue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VCheckbox: lib_["VCheckbox"]
  },
  computed: {
    attributes() {
      let result = Object.assign({}, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      const _this$$listeners = this.$listeners,
            {
        input
      } = _this$$listeners,
            rest = _objectWithoutProperties(_this$$listeners, ["input"]);

      return rest;
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_checkboxvue_type_script_lang_js_ = (c_checkboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-checkbox.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_checkboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_checkbox = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "4875":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4875__;

/***/ }),

/***/ "48cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-text-field.vue?vue&type=template&id=6f3e2244&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({ref:"proxy",attrs:{"value":_vm.value,"error":_vm.hasFieldErrors},on:{"change":_vm.change},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-text-field',_vm.attributes,false),_vm.listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-text-field.vue?vue&type=template&id=6f3e2244&

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-text-field.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};
/* harmony default export */ var c_text_fieldvue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VTextField: lib_["VTextField"]
  },
  computed: {
    attributes() {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      return this.$listeners;
    }

  },
  methods: {
    change(value) {
      let result = this.trimToNull(value);

      if (result !== value) {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-text-field.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_text_fieldvue_type_script_lang_js_ = (c_text_fieldvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-text-field.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_text_fieldvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_text_field = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "4e0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-form.vue?vue&type=template&id=5faabdce&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"c-form",on:{"submit":_vm.formSubmit}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-form.vue?vue&type=template&id=5faabdce&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-form.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var c_formvue_type_script_lang_js_ = ({
  props: {
    preventSubmit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    formSubmit(e) {
      if (this.preventSubmit) {
        e.preventDefault();
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-form.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_formvue_type_script_lang_js_ = (c_formvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-form.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_formvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_form = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "5b4c":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5b4c__;

/***/ }),

/***/ "725c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-currency.vue?vue&type=template&id=a554c100&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({ref:"proxy",attrs:{"value":_vm.value,"error":_vm.hasFieldErrors},on:{"change":_vm.change,"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false}}},'v-text-field',_vm.attributes,false),_vm.listeners),[_c('template',{slot:"prepend-inner"},[_c('span',{staticClass:"currency-prefix"},[_vm._v("\n      "+_vm._s(_vm.$cove.getConfig('format.symbol.currency'))+"\n    ")])])],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-currency.vue?vue&type=template&id=a554c100&

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-currency.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};
/* harmony default export */ var c_currencyvue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VTextField: lib_["VTextField"]
  },

  data() {
    return {
      focused: false
    };
  },

  computed: {
    attributes() {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      return this.$listeners;
    }

  },
  watch: {
    value: {
      immediate: true,

      handler(newValue) {
        if (!this.focused) {
          this.change(newValue);
        }
      }

    }
  },
  methods: {
    change(value) {
      let result = value;

      if (result === undefined || result === null) {
        result = null;
      } else {
        result = String(result);
        result = this.trimToNull(result);

        if (result !== null) {
          let parsed = this.$cove.parseNumber(result);

          if (!isNaN(parsed)) {
            result = this.$cove.formatDecimal(parsed);
          }
        }
      }

      if (result !== value) {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-currency.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_currencyvue_type_script_lang_js_ = (c_currencyvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-currency.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_currencyvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_currency = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "864f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-blocker.vue?vue&type=template&id=4c9447fa&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"scroll-y-transition"}},[(_vm.show)?_c('div',{staticClass:"c-backdrop"},[_c('v-progress-circular',{staticClass:"c-progress",attrs:{"color":"accent","indeterminate":"","size":"100","width":"4"}})],1):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-blocker.vue?vue&type=template&id=4c9447fa&

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-blocker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var c_blockervue_type_script_lang_js_ = ({
  components: {
    VProgressCircular: lib_["VProgressCircular"]
  },

  data() {
    return {
      show: false,
      timeoutID: null
    };
  },

  computed: {
    visible() {
      return this.$store.state.cove.blocker.visible;
    },

    delay() {
      return this.$store.state.cove.blocker.delay;
    }

  },
  watch: {
    visible: {
      immediate: true,

      handler(newValue) {
        if (newValue) {
          this.timeoutID = setTimeout(() => {
            this.show = true;
            window.addEventListener('keydown', preventKeyPress, true);
          }, this.delay);
        } else {
          this.show = false;
          clearTimeout(this.timeoutID);
          window.removeEventListener('keydown', preventKeyPress, true);
        }
      }

    }
  }
});

function preventKeyPress(e) {
  e.preventDefault();
  return false;
}
// CONCATENATED MODULE: ./src/components/c-blocker.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_blockervue_type_script_lang_js_ = (c_blockervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-blocker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_blockervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_blocker = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "885c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-confirm.vue?vue&type=template&id=22e3f80a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-dialog',{attrs:{"value":_vm.visible,"titleKey":"cove.general.confirm","subtitleKey":_vm.subtitleKey,"width":_vm.width,"fullscreen-option":false},on:{"input":_vm.close}},[_c('div',{staticClass:"pa-4"},[_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.typingPromptKey)?_c('div',{staticClass:"mt-8 mb-5 text-center"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('cove.confirm.prompt.prefix'))+"\n        "),_c('span',{staticClass:"blue-grey lighten-5",staticStyle:{"padding":"3px 6px","border-radius":"3px","font-family":"monospace"}},[_vm._v(_vm._s(_vm.$t(_vm.typingPromptKey)))]),_vm._v("\n        "+_vm._s(_vm.$t('cove.confirm.prompt.suffix'))+"\n      ")]),_c('v-text-field',{staticStyle:{"width":"50%","margin":"0 auto"},attrs:{"solo":"","hide-details":"","id":"c-confirm-prompt","placeholder":_vm.$t(_vm.typingPromptKey)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmEnterKey($event)}},model:{value:(_vm.typingConfirmation),callback:function ($$v) {_vm.typingConfirmation=$$v},expression:"typingConfirmation"}},[_c('div',{attrs:{"slot":"append"},slot:"append"},[_c('transition',{attrs:{"name":"scroll-x-transition"}},[(_vm.promptConfirmed)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("\n              mdi-check\n            ")]):_vm._e()],1)],1)])],1):_vm._e()]),_c('template',{slot:"actions-right"},[_c('v-btn',{attrs:{"text":"","color":"primary","disabled":_vm.typingPromptKey && !_vm.promptConfirmed},on:{"click":function($event){return _vm.close(true)}}},[_vm._v("\n      "+_vm._s(_vm.$t('cove.general.ok'))+"\n    ")])],1)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-confirm.vue?vue&type=template&id=22e3f80a&

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-confirm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var c_confirmvue_type_script_lang_js_ = ({
  components: {
    VDialog: lib_["VDialog"],
    VBtn: lib_["VBtn"],
    VIcon: lib_["VIcon"],
    VTextField: lib_["VTextField"]
  },

  data() {
    return {
      typingConfirmation: null
    };
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        this.typingConfirmation = null;

        if (this.typingPromptKey) {
          setTimeout(() => {
            document.querySelector('#c-confirm-prompt').focus();
          }, 200);
        }
      }
    }

  },
  computed: {
    message() {
      return this.$store.state.cove.confirm.message;
    },

    visible() {
      return this.$store.state.cove.confirm.visible;
    },

    width() {
      return this.$store.state.cove.confirm.width;
    },

    subtitleKey() {
      return this.$store.state.cove.confirm.subtitleKey;
    },

    typingPromptKey() {
      return this.$store.state.cove.confirm.typingPromptKey;
    },

    promptConfirmed() {
      return this.typingConfirmation === this.$t(this.typingPromptKey);
    }

  },
  methods: {
    close(value = false) {
      this.$store.commit('cove/confirm/resolve', value);
    },

    confirmEnterKey() {
      if (this.promptConfirmed) {
        this.close(true);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-confirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_confirmvue_type_script_lang_js_ = (c_confirmvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-confirm.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_confirmvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_confirm = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "887d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-date-picker.vue?vue&type=template&id=bf0f7aec&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',_vm._g(_vm._b({ref:"proxy",attrs:{"value":_vm.value,"error":_vm.hasFieldErrors,"appendIcon":"mdi-calendar-month"},on:{"change":_vm.change,"click:append":function($event){_vm.showPicker = true}}},'v-text-field',_vm.attributes,false),_vm.listeners)),_c('v-dialog',{attrs:{"persistent":"","content-class":"c-dialog-datepicker","value":_vm.showPicker,"max-width":"290"}},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":"","dense":""}},[_c('v-toolbar-title',[_vm._v("\n        "+_vm._s(_vm.$t('cove.datepicker.selectDate'))+"\n      ")])],1),_c('v-date-picker',{attrs:{"no-title":"","value":_vm.isoDate,"color":_vm.color},on:{"input":_vm.dateSelected}},[_c('v-spacer'),_c('v-btn',{staticClass:"mr-1 mb-1 px-3",attrs:{"text":"","color":_vm.color},on:{"click":function($event){_vm.showPicker = false}}},[_vm._v("\n        "+_vm._s(_vm.$t('cove.general.cancel'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-date-picker.vue?vue&type=template&id=bf0f7aec&

// EXTERNAL MODULE: external {"commonjs":"luxon","commonjs2":"luxon","amd":"luxon"}
var external_commonjs_luxon_commonjs2_luxon_amd_luxon_ = __webpack_require__("5b4c");

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-date-picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};
/* harmony default export */ var c_date_pickervue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VDialog: lib_["VDialog"],
    VToolbar: lib_["VToolbar"],
    VToolbarTitle: lib_["VToolbarTitle"],
    VSpacer: lib_["VSpacer"],
    VDatePicker: lib_["VDatePicker"],
    VBtn: lib_["VBtn"],
    VTextField: lib_["VTextField"]
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  },

  data() {
    return {
      showPicker: false
    };
  },

  // mounted hook so we can attempt to parse any pre-loaded date shortcut values, e.g. c+5
  mounted() {
    this.change(this.value);
  },

  computed: {
    isoDate() {
      let result = null;
      let parsed = this.$cove.parseDate(this.value);

      if (parsed !== null) {
        result = parsed.toISODate();
      }

      return result;
    },

    attributes() {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      return this.$listeners;
    }

  },
  methods: {
    change(value) {
      let promise = null;
      let result = this.trimToNull(value);

      if (result) {
        let date = this.$cove.parseDate(result);

        if (date !== null) {
          promise = Promise.resolve(this.$cove.formatDate(date));
        } else {
          promise = this.$cove.processDatePickerShortcut(result);
        }
      } else {
        promise = Promise.resolve(result);
      }

      promise.then(v => {
        if (v !== value) {
          this.$emit('input', v);
          this.$emit('change', v);
        }
      });
    },

    dateSelected(str) {
      let isoDate = external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"].fromISO(str);
      let result = this.$cove.formatDate(isoDate);
      this.$emit('input', result);
      this.$emit('change', result);
      this.showPicker = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-date-picker.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_date_pickervue_type_script_lang_js_ = (c_date_pickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-date-picker.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_date_pickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_date_picker = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8b77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-textarea.vue?vue&type=template&id=1a474ac9&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._g(_vm._b({ref:"proxy",attrs:{"value":_vm.value,"error":_vm.hasFieldErrors},on:{"change":_vm.change}},'v-textarea',_vm.attributes,false),_vm.listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-textarea.vue?vue&type=template&id=1a474ac9&

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-textarea.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//


const DEFAULTS = {
  clearable: false,
  rows: 3,
  autoGrow: true,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};
/* harmony default export */ var c_textareavue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VTextarea: lib_["VTextarea"]
  },
  computed: {
    attributes() {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      return this.$listeners;
    }

  },
  methods: {
    change(value) {
      let result = this.trimToNull(value);

      if (result !== value) {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-textarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_textareavue_type_script_lang_js_ = (c_textareavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-textarea.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_textareavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_textarea = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "8de5":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./c-autocomplete.vue": "92e7",
	"./c-blocker.vue": "864f",
	"./c-checkbox.vue": "26f2",
	"./c-confirm.vue": "885c",
	"./c-currency.vue": "725c",
	"./c-date-picker.vue": "887d",
	"./c-dialog.vue": "e4ef",
	"./c-form.vue": "4e0f",
	"./c-snackbar.vue": "9149",
	"./c-text-field.vue": "48cf",
	"./c-textarea.vue": "8b77",
	"./c-time.vue": "b2f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8de5";

/***/ }),

/***/ "9149":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-snackbar.vue?vue&type=template&id=3de54639&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":"","right":"","vertical":"","value":_vm.visible,"color":_vm.color,"timeout":-1},nativeOn:{"mouseenter":function($event){return _vm.mouseEnter($event)},"mouseleave":function($event){return _vm.mouseLeave($event)}},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({staticClass:"mr-1 mb-1 px-3",attrs:{"small":"","color":_vm.color + ' darken-2'},on:{"click":_vm.close}},'v-btn',attrs,false),[_vm._v("\n      "+_vm._s(_vm.$t('cove.general.close'))+"\n    ")])]}}])},[_c('div',{staticClass:"text-body-1 white--text",domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-snackbar.vue?vue&type=template&id=3de54639&

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-snackbar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var c_snackbarvue_type_script_lang_js_ = ({
  components: {
    VBtn: lib_["VBtn"],
    VSnackbar: lib_["VSnackbar"]
  },

  data() {
    return {
      timeout: 5000,
      timerID: null,
      startedTime: null,
      elapsedTime: null
    };
  },

  computed: {
    visible() {
      return this.$store.state.cove.snackbar.visible;
    },

    message() {
      return this.$store.state.cove.snackbar.message;
    },

    color() {
      return this.$store.state.cove.snackbar.color;
    }

  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.elapsedTime = 0;
        this.startedTime = new Date().getTime();
        this.timerID = setTimeout(() => {
          this.close();
        }, this.timeout);
      } else {
        clearTimeout(this.timerID);
      }
    }

  },
  methods: {
    close() {
      this.$store.commit('cove/snackbar/setVisible', false);
    },

    mouseEnter() {
      this.elapsedTime += new Date().getTime() - this.startedTime;
      clearTimeout(this.timerID);
    },

    mouseLeave() {
      if (this.visible) {
        this.startedTime = new Date().getTime();
        this.timerID = setTimeout(() => {
          this.close();
        }, this.timeout - this.elapsedTime);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-snackbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_snackbarvue_type_script_lang_js_ = (c_snackbarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-snackbar.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_snackbarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_snackbar = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "92e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-autocomplete.vue?vue&type=template&id=02f6fff1&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',_vm._g(_vm._b({ref:"proxy",attrs:{"value":_vm.value,"error":_vm.hasFieldErrors},on:{"change":_vm.change},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-autocomplete',_vm.attributes,false),_vm.listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-autocomplete.vue?vue&type=template&id=02f6fff1&

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-autocomplete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const DEFAULTS = {
  clearable: true,
  autoSelectFirst: true,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};
/* harmony default export */ var c_autocompletevue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VAutocomplete: lib_["VAutocomplete"]
  },
  computed: {
    attributes() {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      return this.$listeners;
    }

  },
  methods: {
    change(value) {
      if (value === undefined) {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-autocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_autocompletevue_type_script_lang_js_ = (c_autocompletevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-autocomplete.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_autocompletevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_autocomplete = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "b2f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-time.vue?vue&type=template&id=17b0a1cf&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({ref:"proxy",attrs:{"value":_vm.value,"error":_vm.hasFieldErrors},on:{"change":_vm.change}},'v-text-field',_vm.attributes,false),_vm.listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-time.vue?vue&type=template&id=17b0a1cf&

// EXTERNAL MODULE: ./src/mixins/input.js
var input = __webpack_require__("1047");

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-time.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//


const DEFAULTS = {
  clearable: false,
  autocomplete: 'off',
  spellcheck: 'false',
  autocorrect: 'off',
  autocapitalize: 'off'
};
/* harmony default export */ var c_timevue_type_script_lang_js_ = ({
  mixins: [input["a" /* default */]],
  components: {
    VTextField: lib_["VTextField"]
  },
  computed: {
    attributes() {
      let result = Object.assign({}, DEFAULTS, this.$attrs);
      this.mixinRequired(result);
      return result;
    },

    listeners() {
      return this.$listeners;
    }

  },
  methods: {
    change(value) {
      let result = this.trimToNull(value);

      if (result) {
        let time = this.$cove.parseTime(result);

        if (time !== null) {
          result = this.$cove.formatTime(time);
        }
      }

      if (result !== value) {
        this.$emit('input', result);
        this.$emit('change', result);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-time.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_timevue_type_script_lang_js_ = (c_timevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-time.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_timevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_time = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "e428":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_e428__;

/***/ }),

/***/ "e4ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"bb829f0e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-dialog.vue?vue&type=template&id=3dd4c168&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',_vm._b({attrs:{"persistent":"","scrollable":"","content-class":"c-dialog","fullscreen":_vm.fullscreen,"width":_vm.width,"value":_vm.value}},'v-dialog',_vm.$attrs,false),[_c('v-card',{ref:"card",staticClass:"c-dialog-card"},[_c('v-toolbar',{staticClass:"dialog-toolbar elevation-0",attrs:{"dark":"","dense":"","color":_vm.color}},[_c('v-toolbar-title',[_vm._v("\n        "+_vm._s(_vm.$t(_vm.titleKey))+"\n        "),(_vm.subtitleKey)?_c('span',{staticClass:"c-dialog-subtitle"},[_vm._v("\n          "+_vm._s(_vm.$t(_vm.subtitleKey))+"\n        ")]):_vm._e()]),_c('v-spacer'),_c('v-toolbar-items',[(_vm.fullscreenOption)?_c('v-btn',{staticClass:"px-5",staticStyle:{"min-width":"auto"},attrs:{"text":"","title":_vm.fullscreen ? _vm.$t('cove.dialog.collapse') : _vm.$t('cove.dialog.expand')},on:{"click":_vm.toggleFullScreen}},[_c('v-icon',[_vm._v(_vm._s(_vm.fullscreenIcon))])],1):_vm._e(),_c('v-btn',{staticClass:"px-5",staticStyle:{"min-width":"auto"},attrs:{"text":"","title":_vm.$t('cove.general.close')},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1)],1),_c('v-card-text',[(_vm.showErrors && _vm.errors.length > 0)?_c('v-alert',{staticClass:"ma-4",attrs:{"type":"error","transition":"fade-transition"}},[_c('ul',_vm._l((_vm.errors),function(error,i){return _c('li',{key:i},[_vm._v("\n            "+_vm._s(error)+"\n          ")])}),0)]):_vm._e(),_vm._t("default")],2),_c('v-card-actions',{staticClass:"d-flex"},[_c('div',[_vm._t("actions-left")],2),_c('div',{staticClass:"flex-grow-1"}),_c('div',[_vm._t("actions-right"),_c('v-btn',{attrs:{"text":"","color":"grey darken-3"},on:{"click":_vm.close}},[_vm._v("\n          "+_vm._s(_vm.$t(_vm.closeKey))+"\n        ")])],2)])],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/c-dialog.vue?vue&type=template&id=3dd4c168&

// EXTERNAL MODULE: external {"commonjs":"vuetify/lib","commonjs2":"vuetify/lib","amd":"vuetify/lib"}
var lib_ = __webpack_require__("4875");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/c-dialog.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var c_dialogvue_type_script_lang_js_ = ({
  components: {
    VDialog: lib_["VDialog"],
    VCard: lib_["VCard"],
    VCardTitle: lib_["VCardTitle"],
    VCardActions: lib_["VCardActions"],
    VCardText: lib_["VCardText"],
    VToolbar: lib_["VToolbar"],
    VToolbarItems: lib_["VToolbarItems"],
    VToolbarTitle: lib_["VToolbarTitle"],
    VContainer: lib_["VContainer"],
    VCol: lib_["VCol"],
    VRow: lib_["VRow"],
    VSpacer: lib_["VSpacer"],
    VBtn: lib_["VBtn"],
    VAlert: lib_["VAlert"],
    VIcon: lib_["VIcon"]
  },
  inheritAttrs: false,
  props: {
    titleKey: {
      type: String,
      required: true
    },
    subtitleKey: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: true
    },
    width: {
      default: 800
    },
    closeKey: {
      type: String,
      default: 'cove.general.cancel'
    },
    color: {
      type: String,
      default: 'primary'
    },
    manualClose: {
      type: Boolean,
      default: false
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    fullscreenOption: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      manualFullScreen: false,
      // has the user manually taken control of the popup size
      manualFullScreenToggle: false,
      // the state of the manual popup size
      // define the listener here in data so it's unique per dialog instance
      escListener: e => {
        if (e.keyCode === 27) {
          this.close();
        }
      }
    };
  },

  computed: {
    fullscreen() {
      if (this.manualFullScreen) {
        return this.manualFullScreenToggle;
      } else {
        return this.$vuetify.breakpoint.smAndDown;
      }
    },

    fullscreenIcon() {
      return this.fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen';
    },

    _width() {
      return isNaN(this.width) ? this.width : `${this.width}px`;
    },

    errors() {
      return this.$store.getters['cove/errors/getAllErrorMessages'];
    }

  },
  watch: {
    value: {
      immediate: true,

      handler(newValue) {
        if (newValue) {
          window.addEventListener('keydown', this.escListener);
        } else {
          window.removeEventListener('keydown', this.escListener);
        }
      }

    },

    fullscreen(newValue) {
      this.$emit('fullscreen', newValue);
    }

  },

  destroyed() {
    window.removeEventListener('keydown', this.escListener);
  },

  methods: {
    toggleFullScreen() {
      // determine the new state FIRST, then switch to manual mode
      this.manualFullScreenToggle = !this.fullscreen;
      this.manualFullScreen = true;
    },

    close() {
      // not crazy about this but the esc keydown handlers are called in the order they were added to the DOM, which is
      // the opposite of what we need. so this determines if this component is the topmost active dialog and only then
      // will it activate the close functionality.
      let cards = document.querySelectorAll('.c-dialog-card');
      let currentZ = parseInt(getComputedStyle(this.$refs.card.$el.parentNode.parentNode)['z-index']);
      let maxZ = 0;

      for (let i = 0; i < cards.length; i++) // ECRP-478 - use traditional for loop here
      {
        let d = cards[i];
        let parent = d.parentNode.parentNode;

        if (parent.classList.contains('v-dialog__content--active')) {
          maxZ = Math.max(maxZ, parseInt(getComputedStyle(parent)['z-index']));
        }
      }

      if (currentZ === maxZ) {
        if (this.manualClose) {
          this.$emit('close');
        } else {
          this.$emit('input', false);
        }
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/c-dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_c_dialogvue_type_script_lang_js_ = (c_dialogvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/c-dialog.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_c_dialogvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var c_dialog = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// NAMESPACE OBJECT: ./src/utils/config.js
var config_namespaceObject = {};
__webpack_require__.r(config_namespaceObject);
__webpack_require__.d(config_namespaceObject, "getConfig", function() { return getConfig; });
__webpack_require__.d(config_namespaceObject, "setConfig", function() { return setConfig; });

// NAMESPACE OBJECT: ./src/utils/parse.js
var parse_namespaceObject = {};
__webpack_require__.r(parse_namespaceObject);
__webpack_require__.d(parse_namespaceObject, "parseDate", function() { return parseDate; });
__webpack_require__.d(parse_namespaceObject, "parseISODate", function() { return parseISODate; });
__webpack_require__.d(parse_namespaceObject, "processDatePickerShortcut", function() { return parse_processDatePickerShortcut; });
__webpack_require__.d(parse_namespaceObject, "parseTime", function() { return parseTime; });
__webpack_require__.d(parse_namespaceObject, "parseNumber", function() { return parseNumber; });

// NAMESPACE OBJECT: ./src/utils/format.js
var format_namespaceObject = {};
__webpack_require__.r(format_namespaceObject);
__webpack_require__.d(format_namespaceObject, "formatDate", function() { return formatDate; });
__webpack_require__.d(format_namespaceObject, "formatDateTime", function() { return formatDateTime; });
__webpack_require__.d(format_namespaceObject, "formatTime", function() { return formatTime; });
__webpack_require__.d(format_namespaceObject, "formatNumber", function() { return formatNumber; });
__webpack_require__.d(format_namespaceObject, "formatDecimal", function() { return formatDecimal; });
__webpack_require__.d(format_namespaceObject, "formatCurrency", function() { return formatCurrency; });
__webpack_require__.d(format_namespaceObject, "formatPercent", function() { return formatPercent; });

// NAMESPACE OBJECT: ./src/utils/api.js
var api_namespaceObject = {};
__webpack_require__.r(api_namespaceObject);
__webpack_require__.d(api_namespaceObject, "setAPIs", function() { return setAPIs; });
__webpack_require__.d(api_namespaceObject, "getAPI", function() { return getAPI; });

// NAMESPACE OBJECT: ./src/utils/messages.js
var messages_namespaceObject = {};
__webpack_require__.r(messages_namespaceObject);
__webpack_require__.d(messages_namespaceObject, "nestMessages", function() { return nestMessages; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (false) {}

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"luxon","commonjs2":"luxon","amd":"luxon"}
var external_commonjs_luxon_commonjs2_luxon_amd_luxon_ = __webpack_require__("5b4c");

// CONCATENATED MODULE: ./src/utils/config.js
let configuration = {
  'apiRoot': '/api/v1',
  'appRoot': '/',
  'parse.date': 'MM-dd-yy|MM/dd/yy|MMddyy|MM-dd-yyyy|MM/dd/yyyy|Mmddyyyy',
  'parse.time': 'h:mm a|hh:mm a|h:mma|hh:mma|hmma|hhmma|hha|ha',
  'format.date': 'MM/dd/yyyy',
  'format.dateTime': 'MM/dd/yyyy h:mm a',
  'format.time': 'h:mm a',
  'format.number': '0,0',
  'format.decimal': '0,0.00',
  'format.currency': '$0,0.00',
  'format.percent': '0%',
  'format.symbol.currency': '$',
  'format.symbol.grouping': ',',
  'format.symbol.percent': '%',
  'format.symbol.decimal': '.',
  'locale': 'en-us',
  'timezone': 'America/New_York'
};
/**
 * Returns the configuration value associated with the specified property name. If no key is specified a copy of the
 * entire configuration object will be return instead.
 *
 * @param {String} key optional The requested configuration value
 */

function getConfig(key) {
  if (key === undefined || key === null) {
    return Object.assign({}, configuration);
  } else {
    return configuration[key];
  }
}
/**
 * Sets one or more new configuration values into the master configuration object for the application.
 *
 * @param {Object} config Configuration object containing one or more new configuration values to set
 */

function setConfig(config) {
  Object.assign(configuration, config);
}
// CONCATENATED MODULE: ./src/utils/parse.js

 // strip all non-digit and non-decimal separator characters from a string

const NUMBER_REGEX = new RegExp('[^\\d' + getConfig('format.symbol.decimal') + ']', 'g');
function parseDate(str) {
  if (str === undefined || str === null) {
    return null;
  }

  let date = parseISODate(str);

  if (date !== null) {
    return date;
  }

  let patterns = getConfig('parse.date').split('|');
  patterns.find(p => {
    let test = external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"].fromFormat(str, p);

    if (test.invalid === null) {
      date = test;
    }

    return date !== null;
  });
  return date;
}
function parseISODate(str) {
  if (str === undefined || str === null || !str.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
    return null;
  }

  let date = null;
  let test = external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"].fromISO(str);

  if (test.invalid === null) {
    date = test;
  }

  return date;
} // hook function used to perform date manipulation in our date fields, e.g. "c+7". implementations may choose to
// override this to provide custom functionality. Must return a promise that resolves with the final value (a date
// string properly formatted).

function parse_processDatePickerShortcut(str) {
  return Promise.resolve(str);
}
function parseTime(str) {
  if (str === undefined || str === null) {
    return null;
  }

  let date = parseISODate(str);

  if (date !== null) {
    return date;
  }

  let patterns = getConfig('parse.time').split('|');
  patterns.find(p => {
    let test = external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"].fromFormat(str, p);

    if (test.invalid === null) {
      date = test;
    }

    return date !== null;
  });
  return date;
}
function parseNumber(str) {
  let result = str.replace(NUMBER_REGEX, '');
  return parseFloat(result);
}
// EXTERNAL MODULE: external {"commonjs":"numeral","commonjs2":"numeral","amd":"numeral"}
var external_commonjs_numeral_commonjs2_numeral_amd_numeral_ = __webpack_require__("e428");
var external_commonjs_numeral_commonjs2_numeral_amd_numeral_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_numeral_commonjs2_numeral_amd_numeral_);

// CONCATENATED MODULE: ./src/utils/format.js





function _convertToLuxonDate(date) {
  let dtDate = null;

  if (date instanceof Date) {
    dtDate = external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"].fromJSDate(date);
  } else if (typeof date === 'string') // do not use instanceof here - doesn't work consistently with strings
    {
      dtDate = parseDate(date);

      if (dtDate === null) {
        dtDate = parseISODate(date);
      }
    } else if (date instanceof external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"]) {
    dtDate = date;
  }

  return dtDate;
}

function _formatDate(date, pattern) {
  let result = null;

  let dtDate = _convertToLuxonDate(date);

  if (dtDate instanceof external_commonjs_luxon_commonjs2_luxon_amd_luxon_["DateTime"]) {
    result = dtDate.toFormat(pattern);
  }

  return result;
}

function _formatNumber(value, pattern) {
  let working = value;

  if (typeof value === 'string') {
    working = parseNumber(value);
  }

  let result = value;

  if (typeof working === 'number' && !isNaN(working)) {
    result = external_commonjs_numeral_commonjs2_numeral_amd_numeral_default()(working).format(pattern);
  }

  return result;
}

function formatDate(value) {
  return _formatDate(value, getConfig('format.date'));
}
function formatDateTime(value) {
  return _formatDate(value, getConfig('format.dateTime'));
}
function formatTime(value) {
  return _formatDate(value, getConfig('format.time'));
}
function formatNumber(value) {
  return _formatNumber(value, getConfig('format.number'));
}
function formatDecimal(value) {
  return _formatNumber(value, getConfig('format.decimal'));
}
function formatCurrency(value) {
  return _formatNumber(value, getConfig('format.currency'));
}
function formatPercent(value) {
  return _formatNumber(value, getConfig('format.percent'));
}
// CONCATENATED MODULE: ./src/utils/api.js

const apis = {};
function setAPIs(endpoints) {
  Object.assign(apis, endpoints);
}
function getAPI(options = {}) {
  let mapping = apis[options.name];

  if (mapping === undefined) {
    throw new Error('could not find API url mapping by name: ' + options.name);
  } // prepend the API root location and remove any double slashes that may have occurred after joining them


  let path = mapping.path;
  path = getConfig('apiRoot') + path;
  path = path.replace(/[^:]\/\//g, '/'); // substitute in the path parameters

  if (options.params !== undefined) {
    for (const param in options.params) {
      path = path.replace(':' + param, encodeURIComponent(options.params[param]));
    }
  } // add in any predefined/static query string params with any customizations merged on top


  let queryString = '';
  let mappingQuery = mapping.query !== undefined ? mapping.query : {};
  let optionsQuery = options.query !== undefined ? options.query : {};
  let combinedQuery = Object.assign({}, mappingQuery, optionsQuery);

  for (const name in combinedQuery) {
    if (queryString !== '') {
      queryString += '&';
    }

    queryString += encodeURIComponent(name) + '=' + encodeURIComponent(combinedQuery[name]);
  } // finally, append the computed query string value


  if (queryString !== '') {
    path += '?' + queryString;
  }

  return path;
}
// CONCATENATED MODULE: ./src/utils/messages.js
// convert messages from a flat map of key / value pairs into the nested structure that i18n expects
function nestMessages(flatMsgs) {
  let nestedMsgs = {
    en: {}
  };
  Object.keys(flatMsgs).forEach(key => {
    const split = key.split('.');
    const leaf = split.pop();
    let pointer = nestedMsgs.en;
    split.forEach(s => {
      if (pointer[s] === undefined) {
        pointer[s] = {};
      }

      pointer = pointer[s];
    });
    pointer[leaf] = flatMsgs[key];
  });
  return nestedMsgs;
}
// CONCATENATED MODULE: ./src/utils/constants.js
/* harmony default export */ var constants = ({
  MAX_API_RESULTS_LIMIT: 500 // corresponds to BaseAPIConstants.MAX_RESULTS_LIMIT

});
// CONCATENATED MODULE: ./src/utils/dependency.js
let _store = null;
let _i18n = null;
function init({
  store,
  i18n
}) {
  _store = store;
  _i18n = i18n;
}

// CONCATENATED MODULE: ./src/store/index.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


const BLOCKER_DELAY = 333;
const DEFAULT_CONFIRM_WIDTH = 450;
const stores = {
  namespaced: true,
  modules: {
    // module for containing errors
    errors: {
      namespaced: true,

      state() {
        return {
          errors: []
        };
      },

      getters: {
        getAllErrors(state) {
          return state.errors;
        },

        getAllErrorMessages(state) {
          return state.errors.map(e => {
            return e.message;
          });
        },

        hasErrors(state) {
          return state.errors.length > 0;
        },

        hasFieldErrors(state) {
          return key => {
            let error = state.errors.find(e => {
              return e.key === key;
            });
            return error !== undefined;
          };
        }

      },
      mutations: {
        addError(state, {
          key,
          message
        }) {
          state.errors.push({
            key,
            message
          });
        },

        clear(state) {
          state.errors = [];
        }

      }
    },
    // module for controlling the centralized alert/snackbar notification widget
    snackbar: {
      namespaced: true,

      state() {
        return {
          color: '',
          message: '',
          visible: false
        };
      },

      mutations: {
        show(state, payload) {
          state.color = payload.color;
          state.message = payload.message;
          state.visible = true;
        },

        setVisible(state, value) {
          state.visible = value;
        }

      }
    },
    // module for controlling the screen blocker
    blocker: {
      namespaced: true,

      state() {
        return {
          delay: BLOCKER_DELAY,
          visible: false
        };
      },

      mutations: {
        block(state, {
          delay = BLOCKER_DELAY
        } = {}) {
          state.delay = delay;
          state.visible = true;
        },

        unblock(state) {
          state.visible = false;
        }

      }
    },
    // module for controlling the confirmation dialog
    confirm: {
      namespaced: true,

      state() {
        return {
          message: null,
          subtitleKey: null,
          typingPromptKey: null,
          resolve: null,
          width: null,
          visible: false
        };
      },

      mutations: {
        show(state, {
          message,
          resolve,
          subtitleKey = null,
          typingPromptKey = null,
          width = DEFAULT_CONFIRM_WIDTH
        }) {
          state.message = message;
          state.resolve = resolve;
          state.subtitleKey = subtitleKey;
          state.typingPromptKey = typingPromptKey;
          state.width = width;
          state.visible = true;
        },

        resolve(state, value) {
          state.visible = false;
          state.resolve(value);
        }

      },
      actions: {
        // has to be an action as mutations cannot return values
        show({
          commit
        }, payload) {
          return new Promise(resolve => {
            commit('show', _objectSpread(_objectSpread({}, payload), {}, {
              resolve
            }));
          });
        }

      }
    }
  }
};
const helpers = {
  block(payload) {
    _store.commit('cove/blocker/block', payload);
  },

  unblock() {
    _store.commit('cove/blocker/unblock');
  },

  notify(payload) {
    _store.commit('cove/snackbar/show', payload);
  },

  confirm(payload) {
    return _store.dispatch('cove/confirm/show', payload);
  },

  clearErrors() {
    _store.commit('cove/errors/clear');
  }

};
// CONCATENATED MODULE: ./src/utils/validation.js



function addError(vKey, errorKey, args = []) {
  _store.commit('cove/errors/addError', {
    key: vKey,
    message: _i18n.t(errorKey, args)
  });
}
/**
 * Accepts a string input value and determines if it represents a valid, parseable integer.
 *
 * @param {String} value
 */


const INT_PATTERN = /^(0|-?[1-9]+[0-9]*)$/;

function isInteger(value) {
  let result = false;

  if (typeof value === 'string') {
    result = INT_PATTERN.test(value);
  }

  return result;
}

/* harmony default export */ var validation = ({
  addError,

  /**
   * Rejects the field if it is empty.
   *
   * @param {string} value - field value
   * @param {string} labelKey - field label message key
   * @param {string} vKey - field model key
   *
   * @returns {boolean} - true if validation passes
   */
  required(value, labelKey, vKey) {
    let result = true;

    if (value === undefined || value === null || Array.isArray(value) && value.length === 0) {
      result = false;
      addError(vKey, 'cove.validation.required', [_i18n.t(labelKey)]);
    }

    return result;
  },

  string: {
    /**
     * Rejects the field if it is over a certain length.
     *
     * @param {string} value - field value
     * @param {number} maxLength - max length of the field in characters
     * @param {string} labelKey - field label message key
     * @param {string} vKey - field model key
     *
     * @returns {boolean} - true if validation passes
     */
    maxLength(value, maxLength, labelKey, vKey) {
      let result = true;

      if (value !== undefined && value !== null && typeof value === 'string' && value.length > maxLength) {
        result = false;
        addError(vKey, 'cove.validation.string.maxLength', [_i18n.t(labelKey), maxLength]);
      }

      return result;
    }

  },
  date: {
    /**
     * Rejects if the date is invalid.
     *
     * @param {string} value - field value
     * @param {string} labelKey - field label message key
     * @param {string} vKey - field model key
     *
     * @returns {boolean} - true if validation passes
     */
    rejectIfInvalid(value, labelKey, vKey) {
      let result = true; // empty handled separately

      if (value && !parseDate(value)) {
        result = false;
        addError(vKey, 'cove.validation.date.invalid', [_i18n.t(labelKey)]);
      }

      return result;
    },

    /**
     * Rejects if the first date is before the second date. This will attempt to parse dates both using configured
     * date formats and as ISO8601 strings.
     *
     * @param {string} date1 - first date in string format
     * @param {string} date2 - second date in string format
     * @param {string} labelKey1 - field 1 label message key
     * @param {string} labelKey2 - field 2 label message key
     * @param {string} vKey - field model key of field which will show error
     *
     * @returns {boolean} - true if validation passes
     */
    rejectIfBefore(date1, date2, labelKey1, labelKey2, vKey) {
      let result = true;
      let dt1 = parseDate(date1);
      let dt2 = parseDate(date2);

      if (dt1 && dt2) {
        if (dt1.toMillis() < dt2.toMillis()) {
          result = false;
          addError(vKey, 'cove.validation.date.before', [_i18n.t(labelKey1), _i18n.t(labelKey2)]);
        }
      }

      return result;
    },

    /**
     * Rejects if the first date is after the second date. This will attempt to parse dates both using configured
     * date formats and as ISO8601 strings.
     *
     * @param {string} date1 - first date in string format
     * @param {string} date2 - second date in string format
     * @param {string} labelKey1 - field 1 label message key
     * @param {string} labelKey2 - field 2 label message key
     * @param {string} vKey - field model key of field which will show error
     *
     * @returns {boolean} - true if validation passes
     */
    rejectIfAfter(date1, date2, labelKey1, labelKey2, vKey) {
      let result = true;
      let dt1 = parseDate(date1);
      let dt2 = parseDate(date2);

      if (dt1 && dt2) {
        if (dt1.toMillis() > dt2.toMillis()) {
          result = false;
          addError(vKey, 'cove.validation.date.after', [_i18n.t(labelKey1), _i18n.t(labelKey2)]);
        }
      }

      return result;
    }

  },
  integer: {
    /**
     * Rejects if the value is not a valid integer. Ignores empty values.
     *
     * @param {string} value
     * @param {string} labelKey
     * @param {string} vKey
     *
     * @return {boolean} - true if validation passes
     */
    rejectIfInvalid(value, labelKey, vKey) {
      let result = true;

      if (!isInteger(value)) {
        result = false;
        addError(vKey, 'cove.validation.integer.invalid', [_i18n.t(labelKey)]);
      }

      return result;
    },

    /**
     * Rejects if the integer value is less than a given number. Ignores non-integer values.
     *
     * @param {string} value
     * @param {number} minValue
     * @param {string} labelKey
     * @param {string} vKey
     *
     * @return {boolean} - true if validation passes
     */
    rejectIfLessThan(value, minValue, labelKey, vKey) {
      let result = true;

      if (!Number.isInteger(minValue)) {
        throw new Error('Error - comparison value must be integer');
      }

      let valueInt = Number(value);

      if (isInteger(value) && valueInt < minValue) {
        result = false;
        addError(vKey, 'cove.validation.integer.lessThan', [_i18n.t(labelKey), minValue]);
      }

      return result;
    },

    /**
     * Rejects if the integer value is less than or equal to a given number. Ignores non-integer values.
     *
     * @param {string} value
     * @param {number} minValue
     * @param {string} labelKey
     * @param {string} vKey
     *
     * @return {boolean} - true if validation passes
     */
    rejectIfLessThanEqualTo(value, minValue, labelKey, vKey) {
      let result = true;

      if (!Number.isInteger(minValue)) {
        throw new Error('Error - comparison value must be integer');
      }

      let valueInt = Number(value);

      if (isInteger(value) && valueInt <= minValue) {
        result = false;
        addError(vKey, 'cove.validation.integer.lessThanEqualTo', [_i18n.t(labelKey), minValue]);
      }

      return result;
    },

    /**
     * Rejects if the integer value is greater than a given number. Ignores non-integer values.
     *
     * @param {string} value
     * @param {number} maxValue
     * @param {string} labelKey
     * @param {string} vKey
     */
    rejectIfGreaterThan(value, maxValue, labelKey, vKey) {
      let result = true;

      if (!Number.isInteger(maxValue)) {
        throw new Error('Error - comparison value must be integer');
      }

      let valueInt = Number(value);

      if (isInteger(value) && valueInt > maxValue) {
        result = false;
        addError(vKey, 'cove.validation.integer.greaterThan', [_i18n.t(labelKey), maxValue]);
      }

      return result;
    },

    /**
     * Rejects if the integer value is greater than or equal to a given number. Ignores non-integer values.
     *
     * @param {string} value
     * @param {number} maxValue
     * @param {string} labelKey
     * @param {string} vKey
     */
    rejectIfGreaterThanEqualTo(value, maxValue, labelKey, vKey) {
      let result = true;

      if (!Number.isInteger(maxValue)) {
        throw new Error('Error - comparison value must be integer');
      }

      let valueInt = Number(value);

      if (isInteger(value) && valueInt >= maxValue) {
        result = false;
        addError(vKey, 'cove.validation.integer.greaterThanEqualTo', [_i18n.t(labelKey), maxValue]);
      }

      return result;
    }

  },
  time: {
    /**
     * Rejects if the time is invalid.
     *
     * @param {string} value - field value
     * @param {string} labelKey - field label message key
     * @param {string} vKey - field model key
     *
     * @returns {boolean} - true if validation passes
     */
    rejectIfInvalid(value, labelKey, vKey) {
      let result = true; // empty handled separately

      if (value && !parseTime(value)) {
        result = false;
        addError(vKey, 'cove.validation.time.invalid', [_i18n.t(labelKey)]);
      }

      return result;
    }

  },
  number: {
    /**
     * Rejects if the number amount is invalid.
     *
     * @param {string} value - field value
     * @param {string} labelKey - field label message key
     * @param {string} vKey - field model key
     *
     * @returns {boolean} - true if validation passes
     */
    rejectIfInvalid(value, labelKey, vKey) {
      let result = true;

      if (value && Number.isNaN(parseNumber(value))) {
        result = false;
        addError(vKey, 'cove.validation.number.invalid', [_i18n.t(labelKey)]);
      }

      return result;
    },

    /**
     * Rejects if the number value is less than a given number.
     *
     * @param {string} value
     * @param {number} minValue
     * @param {string} labelKey
     * @param {string} vKey
     *
     * @return {boolean} - true if validation passes
     */
    rejectIfLessThan(value, minValue, labelKey, vKey) {
      let result = true;

      if (Number.isNaN(minValue)) {
        throw new Error('Error - comparison value must be a number');
      }

      if (value) {
        let valueNum = parseNumber(value);

        if (!Number.isNaN(valueNum) && valueNum < minValue) {
          result = false;
          addError(vKey, 'cove.validation.number.lessThan', [_i18n.t(labelKey), minValue]);
        }
      }

      return result;
    },

    /**
     * Rejects if the number value is less than or equal to a given number.
     *
     * @param {string} value
     * @param {number} minValue
     * @param {string} labelKey
     * @param {string} vKey
     *
     * @return {boolean} - true if validation passes
     */
    rejectIfLessThanEqualTo(value, minValue, labelKey, vKey) {
      let result = true;

      if (Number.isNaN(minValue)) {
        throw new Error('Error - comparison value must be a number');
      }

      if (value) {
        let valueNum = parseNumber(value);

        if (!Number.isNaN(valueNum) && valueNum <= minValue) {
          result = false;
          addError(vKey, 'cove.validation.number.lessThanEqualTo', [_i18n.t(labelKey), minValue]);
        }
      }

      return result;
    },

    /**
     * Rejects if the number value is greater than a given number.
     *
     * @param {string} value
     * @param {number} maxValue
     * @param {string} labelKey
     * @param {string} vKey
     */
    rejectIfGreaterThan(value, maxValue, labelKey, vKey) {
      let result = true;

      if (Number.isNaN(maxValue)) {
        throw new Error('Error - comparison value must be a number');
      }

      if (value) {
        let valueNum = parseNumber(value);

        if (!Number.isNaN(valueNum) && valueNum > maxValue) {
          result = false;
          addError(vKey, 'cove.validation.number.greaterThan', [_i18n.t(labelKey), maxValue]);
        }
      }

      return result;
    },

    /**
     * Rejects if the number value is greater than or equal to a given number.
     *
     * @param {string} value
     * @param {number} maxValue
     * @param {string} labelKey
     * @param {string} vKey
     */
    rejectIfGreaterThanEqualTo(value, maxValue, labelKey, vKey) {
      let result = true;

      if (Number.isNaN(maxValue)) {
        throw new Error('Error - comparison value must be a number');
      }

      if (value) {
        let valueNum = parseNumber(value);

        if (!Number.isNaN(valueNum) && valueNum >= maxValue) {
          result = false;
          addError(vKey, 'cove.validation.number.greaterThanEqualTo', [_i18n.t(labelKey), maxValue]);
        }
      }

      return result;
    }

  }
});
// CONCATENATED MODULE: ./src/utils/pagination.js

const PAGING_DEFAULTS = {
  itemsPerPage: 25,
  page: 1,
  sortBy: [],
  sortDesc: []
};

function defaultTo(value, defaultValue) {
  let result = defaultValue;

  if (value !== undefined && value !== null) {
    result = value;
  }

  return result;
}

function defaultToNumber(value, defaultValue) {
  return isNaN(value) ? defaultValue : parseInt(value);
}

class pagination_Pagination {
  /**
   * Static utility to quickly generate paging headers used to make a max result paging request. Optionally allows for
   * specifying sorting information.
   *
   * @param {String} sortBy
   * @param {String} sortDirection
   */
  static generateMaxHeaders(sortBy, sortDirection = 'asc') {
    let headers = {
      'X-CTrack-Paging-StartIndex': 1,
      'X-CTrack-Paging-MaxResults': constants.MAX_API_RESULTS_LIMIT
    };

    if (sortBy) {
      headers['X-CTrack-Paging-OrderBy'] = sortBy + ' ' + sortDirection;
    }

    return headers;
  }
  /**
  * Standard constructor
  *
  * @param options [Object] an object allowing for overrides of the default paging settings
  */


  constructor(options = {}) {
    this.itemsPerPage = defaultToNumber(options.itemsPerPage, PAGING_DEFAULTS.itemsPerPage);
    this.page = defaultToNumber(options.page, PAGING_DEFAULTS.page);
    this.sortBy = defaultTo(options.sortBy, PAGING_DEFAULTS.sortBy);
    this.sortDesc = defaultTo(options.sortDesc, PAGING_DEFAULTS.sortDesc);
    this.totalItems = 0;
    this.accessibleItems = 0;
  }
  /**
  * Converts this paging state's current state into a set of paging headers for a request.
  *
  * @returns {Object}
  */


  generateHeaders() {
    let headers = {
      'X-CTrack-Paging-StartIndex': (this.page - 1) * this.itemsPerPage + 1,
      'X-CTrack-Paging-MaxResults': this.itemsPerPage,
      'X-CTrack-Paging-CalculateTotalCount': true
    }; // the server cannot handle null sort values, so only set this header if a sort was specified

    if (this.sortBy[0] !== undefined && this.sortBy[0] !== null) {
      headers['X-CTrack-Paging-OrderBy'] = this.sortBy[0] + ' ' + (this.sortDesc[0] ? 'desc' : 'asc');
    }

    return headers;
  }
  /**
  * Parses the response headers from the specified AJAX call and updates this paging state
  * to reflect the data in the response.
  *
  * @param response [Object] the AJAX response object
  */


  parseHeaders(response) {
    this.totalItems = parseInt(response.headers['x-ctrack-paging-totalcount']);
    this.accessibleItems = this.totalItems;
    let limitHeader = response.headers['x-ctrack-paging-resultslimit'];

    if (limitHeader !== undefined && limitHeader !== null) {
      let maxResultsAllowed = parseInt(limitHeader);

      if (maxResultsAllowed > 0 && this.accessibleItems > maxResultsAllowed) {
        this.accessibleItems = maxResultsAllowed;
        this.accessibleItems -= this.accessibleItems % this.itemsPerPage;
      }
    }
  }
  /**
   * Returns an object representing this internal state of this paging object so it can be encoded into the URL and
   * decoded at some later point.
   *
   * @returns [Object]
   */


  generateURLParams() {
    let params = {
      'p.page': this.page
    };

    if (this.sortBy[0] !== undefined && this.sortBy[0] !== null) {
      params['p.sortBy'] = this.sortBy[0];
      params['p.sortDesc'] = this.sortDesc[0];
    }

    return params;
  }
  /**
   * Used as callback / sync operation when vuetify detects a paging change. Updates the internal state of our paging object to reflect the
   * change. Sometimes we get false updates from vuetify so we'll manually check to see if anything actually changed.
   *
   * Additionally, a callback can be supplied (onChange) which will activate only if we detect a change. Useful to trigger the actual AJAX
   * paging request.
   *
   * @param {object} newPaging
   * @param {function} onChange
   */


  update(newPaging, onChange = () => {}) {
    let hasChanged = this.page !== newPaging.page || this.sortBy[0] !== newPaging.sortBy[0] || this.sortDesc[0] !== newPaging.sortDesc[0];
    this.page = newPaging.page;
    this.sortBy = newPaging.sortBy;
    this.sortDesc = newPaging.sortDesc;

    if (hasChanged) {
      onChange();
    }
  }

}
// CONCATENATED MODULE: ./src/lib.js
function lib_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function lib_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { lib_ownKeys(Object(source), true).forEach(function (key) { lib_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { lib_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function lib_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












const extensions = lib_objectSpread(lib_objectSpread(lib_objectSpread(lib_objectSpread(lib_objectSpread(lib_objectSpread(lib_objectSpread({
  Pagination: pagination_Pagination,
  validation: validation
}, config_namespaceObject), parse_namespaceObject), format_namespaceObject), api_namespaceObject), messages_namespaceObject), helpers), {}, {
  const: constants
});

/* harmony default export */ var lib = (lib_objectSpread({
  install(Vue, {
    store,
    i18n,
    processDatePickerShortcut
  }) {
    // store reference to our dependencies
    init({
      store,
      i18n
    }); // install all formatting functions as Vue filters

    Vue.mixin({
      filters: lib_objectSpread({}, format_namespaceObject)
    }); // register the Cove Vuex modules

    store.registerModule('cove', stores); // register the Cove components

    let requireComponent = __webpack_require__("8de5");

    requireComponent.keys().forEach(fileName => {
      const componentConfig = requireComponent(fileName);
      const componentName = fileName.replace(/^\.\//, '').replace(/\.vue$/, '');
      Vue.component(componentName, componentConfig.default || componentConfig);
    });

    if (processDatePickerShortcut) {
      extensions.processDatePickerShortcut = processDatePickerShortcut;
    } // expose all Cove functionality on $cove


    Vue.prototype.$cove = extensions;
  }

}, extensions));
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (lib);



/***/ })

/******/ });
});
//# sourceMappingURL=cove.umd.js.map